<script setup>
import { ref } from 'vue'
import { SAlert, SText } from '@n966/soilbox_ui'

const emits = defineEmits(['close-alert'])

let isShowAlert = ref(true)

const closeAlert = () => {
  isShowAlert.value = false
  emits('close-alert')
}
</script>
<template>
  <s-alert
    v-if="isShowAlert"
    icon="circle-info"
    class="alert"
    type="primary"
    text-small
    closable
    @close-alert="closeAlert"
  >
    <s-text small>
      Заполните или скопируйте (Ctrl-C) из таблицы excel координаты WGS-84
      (Garmin) в <strong>десятичных градусах</strong> и автоматически получите
      значения координат в МСК согласно ГОСТ 32453-2017. Автоматическое
      определение зон происходит при пересчете из WGS в МСК. При пересчете из
      МСК в WGS необходимо выбрать номер зоны вручную
    </s-text>
  </s-alert>
</template>

<style lang="scss">
.alert {
  & .s-icon {
    font-size: 22px;
  }
}
</style>
